import React, {useEffect} from 'react'
import './FAQCard.scss'
import {showInHeadlessMode} from "wipi-common/src/lib/util";
import {useI18nContext} from "../i18n/I18nContext";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";
import PropTypes from "prop-types";
import Accordion from "react-bootstrap/esm/Accordion";

export default function FAQCard({ cardId, header, body }) {
    const context = useI18nContext()

    useEffect(() => {
        showInHeadlessMode()
    })

    return (
        <Accordion.Item eventKey={cardId}>
            <Accordion.Header id={"heading-"+cardId}><strong>{getI18nTextWithContext(context, header)}</strong></Accordion.Header>
            <Accordion.Body id={"collapse-"+cardId} dangerouslySetInnerHTML={{ __html: getI18nTextWithContext(context, body) }} />
        </Accordion.Item>
    )
}

FAQCard.propTypes = {
    cardId: PropTypes.number.isRequired,
    header: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired
}